import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import Link from "../../../../../general/Link";
import * as s from "./LinkListItem.module.scss";

type LinkListItemProps = {
	linkText: string;
	href?: string;
	onClick?: () => void;
	target?: string | null;
	anchor?: string;
	inModule?: boolean;
};

const LinkListItem: FC<LinkListItemProps> = ({
	linkText,
	href,
	onClick,
	target,
	anchor,
	inModule,
}) => {
	if (href) {
		return (
			<li className={s.listItem}>
				<Link
					href={href}
					className={cn(s.link, { [s.inModule]: inModule })}
					target={target ?? undefined}
					anchor={anchor}
				>
					{linkText}
				</Link>
			</li>
		);
	}

	if (onClick) {
		return (
			<li className={s.listItem}>
				<button
					className={cn(s.button, s.link, { [s.inModule]: inModule })}
					onClick={onClick}
				>
					{linkText}
				</button>
			</li>
		);
	}
};

export default LinkListItem;
